import { PropsWithChildren } from "react";

/**
 * A secondary button that is identified by a transparent
 * background and outlined border
 */
const OutlineButton = ({
  type,
  className,
  children,
  disabled,
  onClick
}: PropsWithChildren<{
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}>) => (
  <button
    type={type || "button"}
    disabled={disabled}
    className={
      "flex items-center justify-center rounded-xl border-[1px] px-5 py-2 text-sm transition " +
      className +
      (disabled
        ? " border-ctb-grey-200 text-ctb-grey-200 hover:cursor-default"
        : " border-ctb-blue-400 font-medium text-ctb-blue-600 hover:border-ctb-blue-200 hover:bg-ctb-blue-600 hover:text-white")
    }
    onClick={onClick}
  >
    {children}
  </button>
);

export default OutlineButton;
